import { Box, Drawer, IconButton, Stack } from "@mui/material";
import { UserContext } from "App";
import { useSnackbar } from "layouts/ecommerce/product/hooks/SnackbarProvider";
import { Fragment, memo, useContext, useEffect, useMemo } from "react";
import { emit } from "react-native-react-bridge/lib/web";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { activeSessionDay, getActiveSession, logoutSession } from "../../../../config/Services";
import { stopNotificationPolling } from "../../../../utils/notificationSystem/orderNotificationPollingService";
import "./Menu.css";
import { getMobilePos } from "./redux/Reducers/paginationReducer";

import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import DarkModeIcon from "@mui/icons-material/DarkMode";
import ExitToAppOutlinedIcon from "@mui/icons-material/ExitToAppOutlined";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import HourglassTopOutlinedIcon from "@mui/icons-material/HourglassTopOutlined";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import LayersOutlinedIcon from "@mui/icons-material/LayersOutlined";
import LightModeIcon from "@mui/icons-material/LightMode";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
import PersonOutlinedIcon from "@mui/icons-material/PersonOutlined";
import ReceiptLongOutlinedIcon from "@mui/icons-material/ReceiptLongOutlined";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import Brightness4OutlinedIcon from "@mui/icons-material/Brightness4Outlined";
import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";
import {
  getFromLocalStorage,
  removeFromLocalStorage,
  setInLocalStorage,
} from "../../../../utils/localStorageHelpers";

const Menu = ({ openMenu, setOpenMenu } = {}) => {
  const navigate = useNavigate();
  const showSnackbar = useSnackbar();
  const isMobilePos = useSelector(getMobilePos);
  const { color, setColor, setIsLoadingScreen } = useContext(UserContext);

  const retailUserDetails = JSON.parse(localStorage.getItem("retailUserDetails"));
  const firstName = retailUserDetails?.firstName;
  const secondName = retailUserDetails?.secondName;
  const sessionUidx = retailUserDetails?.uidx;
  const sessionlocId = localStorage.getItem("locId");
  const sessionId = localStorage.getItem("sessionId");
  const profilePic = localStorage.getItem("logoUrl");
  const orgName = localStorage.getItem("orgName");

  const showOdsTab = getFromLocalStorage("orgConfig")?.odsScreen;
  // const showOdsTab = true;

  const handleRedirect = async (path) => {
    setIsLoadingScreen(true);
    let daySessionId = getFromLocalStorage("daySessionId");
    try {
      if (!daySessionId) {
        const res = await activeSessionDay(sessionlocId);
        if (res?.data?.statusCode === 300) {
          throw new Error(res?.data?.statusCode);
        }
        setInLocalStorage("daySessionId", res?.data?.userSession?.sessionId);
        daySessionId = res?.data?.userSession?.sessionId;
      }

      const res = await getActiveSession(sessionUidx, sessionlocId, daySessionId);
      if (res?.data?.statusCode === 300) {
        throw new Error(res?.data?.statusCode);
      }
      if (res?.data?.hasOwnProperty("machines")) {
        setInLocalStorage("machineId", res?.data?.machines?.[0].machineId || 0);
        setInLocalStorage("storeMode", "ONLINE");
      }
      setInLocalStorage("sessionId", res?.data?.userSession?.sessionId);
      setInLocalStorage("licenseId", res?.data?.userSession?.licenseId);
      navigate(path);
    } catch (error) {
      if (error?.message === "300") {
        removeFromLocalStorage("sessionId");
        removeFromLocalStorage("licenseId");
        navigate("/session-page/start-day");
        return;
      }
      showSnackbar(error?.message || error?.response?.data?.message, "error");
    } finally {
      setOpenMenu(false);
      setIsLoadingScreen(false);
    }
  };

  const routes = useMemo(
    () => [
      {
        label: "Cart",
        icon: <ShoppingCartOutlinedIcon />,
        redirect: () => {
          handleRedirect("/restaurant/cart");
        },
      },
      {
        label: "Customers",
        icon: <PersonOutlinedIcon />,
        redirect: () => {
          handleRedirect("/products/customertable");
        },
      },
      {
        label: "Orders",
        icon: <ReceiptLongOutlinedIcon />,
        redirect: () => {
          handleRedirect("/products/orderstable");
        },
      },

      {
        label: "Sessions",
        icon: <LayersOutlinedIcon />,
        redirect: () => {
          handleRedirect("/session-page/session-listing");
        },
      },
    ],
    []
  );

  const settings = useMemo(
    () => [
      {
        label: "Home",
        icon: <HomeOutlinedIcon />,
        redirect: () => {
          handleRedirect("/dashboard");
        },
      },
      {
        label: "Hold orders",
        icon: <HourglassTopOutlinedIcon />,
        redirect: () => {
          handleRedirect("/products/holdorderpage");
        },
      },
      {
        label: "Delivery",
        icon: <LocalShippingIcon className={`${!showOdsTab && "delivery-tab-status"}`} />,
        redirect: () => {
          if (showOdsTab) {
            const retailType = localStorage.getItem("retailType");
            if (retailType === "RESTAURANT") {
              handleRedirect("/orders");
            } else {
              handleRedirect("/orders");
            }
            setOpenMenu(false);
          } else {
            showSnackbar("You are not authorized", "error");
          }
        },
      },
      {
        label: "Settings",
        icon: <SettingsOutlinedIcon />,
        redirect: () => {
          handleRedirect("/settings");
        },
      },
      {
        label: "Select location",
        icon: <LocationOnOutlinedIcon />,
        redirect: () => {
          handleLocation();
        },
      },
      {
        label: "Sign out",
        icon: <ExitToAppOutlinedIcon />,
        redirect: () => {
          logout();
        },
      },
    ],
    [color]
  );

  const changeColorFun = () => {
    if (color == "dark") {
      setColor("light");
      localStorage.setItem("color", "light");
      isMobilePos &&
        emit({
          type: "localData",
          data: {
            color: "light",
          },
        });
      document.body.classList.remove("dark");
    }
    if (color == "light") {
      setColor("dark");
      localStorage.setItem("color", "dark");
      isMobilePos &&
        emit({
          type: "localData",
          data: {
            color: "dark",
          },
        });
      document.body.classList.add("dark");
    }
  };

  const handleLocation = () => {
    if (sessionId) {
      showSnackbar("Close session to change location", "warning");
    } else {
      handleRedirect("/products/location");
    }
    setOpenMenu(false);
  };

  const clearLocalStorage = () => {
    isMobilePos &&
      emit({
        type: "localData",
        data: null,
      });

    Object.keys(localStorage).forEach((key) => {
      if (key !== "printerConfig") {
        localStorage.removeItem(key);
      }
    });
    navigate("/");
    window.location.reload();
  };

  const logout = () => {
    if (sessionId) {
      showSnackbar("Close session to signout", "warning");
    } else {
      stopNotificationPolling();
      logoutSession()
        .then((res) => {
          showSnackbar("Successfully Logged out", "success");
          clearLocalStorage();
        })
        .catch((err) => {
          showSnackbar(err?.response?.data?.message || err?.message, "error");
          clearLocalStorage();
        });
    }
    setOpenMenu(false);
  };

  const goToProfile = () => {
    navigate("/settings/accounts");
  };

  useEffect(() => {
    const computedStyleMap = document.getElementsByTagName("body")[0];
    if (color === "dark") {
      computedStyleMap.style.backgroundColor = "#2b2f42";
    } else {
      // computedStyleMap.style.backgroundColor = "#f7f7ff";
      computedStyleMap.style.backgroundColor = "#F5F5F5";
    }
    if (localStorage.getItem("color") === "dark") {
      setColor("dark");
    } else {
      setColor("light");
    }
  }, [color]);

  const toggleDrawer = (open) => (event) => {
    if (event.type === "keydown" && (event.key === "Tab" || event.key === "Shift")) {
      return;
    }

    setOpenMenu(open);
  };

  const refresh = () => {
    window.location.reload();
  };

  return (
    <Drawer
      anchor="right"
      open={openMenu}
      onClose={toggleDrawer(false)}
      PaperProps={{
        sx: {
          width: "100%",
          backgroundColor: color === "dark" ? "var(--dark-background)" : "var(--main-background)",
        },
      }}
      sx={{
        zIndex: 1202,
      }}
    >
      <Box className={`menu-container ${color}`}>
        <Stack direction="column" justifyContent="center" spacing={2}>
          <Box mt={2}>
            <ArrowBackIosNewIcon
              className="paymentPageBackBtn"
              onClick={() => setOpenMenu(false)}
            />
          </Box>
          <Box className="user-details-card">
            <Stack direction="row" justifyContent="space-between" alignItems="center">
              <Box>
                <div className="user-name">
                  {firstName} {secondName}
                </div>
                <div>{orgName}</div>
                <div className="view-profile-text" onClick={goToProfile}>
                  View Profile <ArrowRightIcon sx={{ fontSize: "1rem" }} />
                </div>
              </Box>
              <Box sx={{ display: "flex" }} onClick={refresh}>
                <img src={profilePic} alt="profile" className="profile-pic" />
              </Box>
            </Stack>
          </Box>
          <Box>
            <Stack direction="row" justifyContent="space-between" spacing={1}>
              {routes.map((route, index) => (
                <Box key={index} onClick={route?.redirect} className="route-card">
                  {route?.icon}
                  <div>{route?.label}</div>
                </Box>
              ))}
            </Stack>
          </Box>
          <Box className="settings-container">
            <Stack justifyContent="space-between" spacing={1.5}>
              {settings.map((setting, index) => (
                <Fragment key={index}>
                  <Box onClick={setting?.redirect} className="settings-card">
                    <Box className="settings-card-content">
                      <div className="settings-card-icon">{setting?.icon}</div>
                      <div
                        className={`${
                          setting?.label === "Delivery" && !showOdsTab && "delivery-tab-status"
                        }`}
                      >
                        {setting?.label}
                      </div>
                    </Box>
                    <KeyboardArrowRightIcon
                      className={`${
                        setting?.label === "Delivery" && !showOdsTab && "delivery-tab-status"
                      }`}
                    />
                  </Box>
                  {index < settings.length - 1 && <hr style={{ opacity: 0.3 }} />}
                </Fragment>
              ))}
            </Stack>
          </Box>
        </Stack>
        <div className="fixed-icon-container" onClick={changeColorFun}>
          <IconButton size="large" color="inherit">
            {color === "dark" ? <LightModeIcon /> : <DarkModeIcon />}
          </IconButton>
        </div>
      </Box>
    </Drawer>
  );
};

export default memo(Menu);
